/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';


export const medical_tests : {[key: string]: Array<[string, string]>} = {
};
